/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Model_Breakdown_TitleInputs */



/**
* | output |
* | --- |
* | "Model Breakdown" |
*
* @param {Dashboard_Model_Breakdown_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_model_breakdown_title = /** @type {((inputs?: Dashboard_Model_Breakdown_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Model_Breakdown_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Modellaufschlüsselung")
	return /** @type {LocalizedString} */ ("Model Breakdown")
});